import { useLocation } from 'react-router'
import { useSetRecoilState } from 'recoil'
import { currentDetailLevelState } from 'store/atoms'
import usePreference from './usePreference'

const useDetailLevel = (processId) => {
	const location = useLocation()
	const setCurrentDetailLevel = useSetRecoilState(currentDetailLevelState)
	const [detailLevelPerTab, setDetailLevelPerTab] = usePreference(
		'detailLevelPerTab',
		'{"root": "detailed", "appointments": "detailed", "requisitions": "detailed", "comments": "detailed", "clinical-evaluations-predictions": "detailed"}',
		JSON.parse
	)

	const tab = location.pathname.split('/').pop()

	const selectedTab = tab === processId || tab === '' ? 'root' : tab

	const getDetailLevel = () => {
		setCurrentDetailLevel(detailLevelPerTab[selectedTab])
		return detailLevelPerTab[selectedTab]
	}

	const setDetailLevel = (value) => {
		setDetailLevelPerTab((prev) => {
			const nextState = {
				...prev,
				[selectedTab]: value,
			}

			setCurrentDetailLevel(value)

			return JSON.stringify(nextState)
		})
	}

	return [getDetailLevel, setDetailLevel]
}

export default useDetailLevel
